<template>
  <fragment>
    <v-data-table v-if="isMonthly && monthlyAttends" :headers="headers" :items="monthlyAttends" sort-by="name"
      :search="search" item-key="_id" dense hide-default-footer @page-count="pageCount = $event" :page.sync="page"
      :items-per-page="itemsPerPage" no-data-text="No hay resultados" no-results-text="No hay resultados"
      @click:row="$router.push(`/dashboard/planilla/attend/${$event._id}`)">
      <template v-slot:top>
        <v-row class="px-3">
          <v-col cols="12" sm="6">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
              hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <date-filter @onSelectDate="onFilter($event)" isMonthly />
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-pagination class="py-5" v-model="page" :length="pageCount" :total-visible="10">
        </v-pagination>
      </template>
    </v-data-table>

    <attend-table v-else-if="empAttends && !isMonthly" :empAttends="empAttends">
      <template v-slot:filter>
        <v-col cols="12" sm="6">
          <date-filter @onSelectDate="onFilter($event)" />
        </v-col>
      </template>
    </attend-table>
    <router-view :filterBy="filterBy" />
  </fragment>
</template>

<script>
import { tableHeader } from '@/services/constData.js';
import AttendTable from './AttendTable';
import DateFilter from '../Misc/DateFilter';
import { getFirstLastDay, UTCReady, toUTC, getDateUTC } from '@/services/timeUtils.js';
export default {
  data() {
    return {
      search: '',
      page: 1,
      itemsPerPage: 20,
      pageCount: 1,
      filterBy: null
    };
  },
  created() {
    this.headers = tableHeader.attendReport;
    this.getTableData();
  },
  methods: {
    async getTableData() {
      if (this.isMonthly || !this.currentView) {
        this.filterBy = this.filterBy || getFirstLastDay(new Date());
        await this.loadMonthlyAttends(this.filterBy);
      } else if (this.isDaily) {
        this.filterBy = this.filterBy || { date: new Date() };
        await this.loadDailyAttend(this.filterBy);
      }
    },
    loadMonthlyAttends(filterBy) {
      return this.$store.dispatch({ type: 'loadMonthlyAttends', ...filterBy });
    },
    loadDailyAttend(filterBy) {
      return this.$store.dispatch({ type: 'loadDailyAttend', ...filterBy });
    },
    onFilter(date) {
      this.filterBy = this.isMonthly ? getFirstLastDay(date) : { date };
      this.search = '';
      this.getTableData();
    }
  },
  computed: {
    currentView() {
      return this.$route.query.type;
    },
    isMonthly() {
      return this.currentView === 'mensual';
    },
    isDaily() {
      return this.currentView === 'diaria';
    },
    empAttends() {
      return this.$store.getters.empAttends;
    },
    monthlyAttends() {
      return this.$store.getters.monthlyAttends;
    }
  },
  watch: {
    currentView(to, from) {
      this.filterBy = null;
      this.search = '';
      this.getTableData();
    }
  },
  components: {
    AttendTable,
    DateFilter
  }
}
</script>